import Relation from '../common/relation'

const state = Object.assign({}, Relation.state)
state.endpointParent = 'parent'
state.endpointChild = 'child'

export default {
  namespaced: true,
  state,
  getters: Relation.getters,
  mutations: Relation.mutations,
  actions: Relation.actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/files/parentChild.js